import { Reducer } from 'redux';

import { DEFAULT_ENVIRONMENTS } from '../constants';
import { ActionTypes } from '../types/action-types';
import { ActionObject, ISFConfig } from '../types/config';

export default ((state = {
  enabled: false,
  mapping: {
  },
  environment: DEFAULT_ENVIRONMENTS
}, action: ActionObject): ISFConfig => {
  switch (action.type) {
    case ActionTypes.CONFIG_LOADED:
      return {
        ...action.config,
      };
  }
  return {...state};
}) as Reducer<ISFConfig>;



// WEBPACK FOOTER //
// ./src/sub-projects/salesforce/reducers/config.ts